import PropTypes from 'prop-types';
import HookFormTextInput from 'components/cef_form/hook-form/HookFormTextInput';

const AdditionalContacts = ({ id, inputs, required, values }) => (
  <>
    {inputs.map(
      ({ id: inputId, label, type, requiredErrorMessage, pattern }) => (
        <HookFormTextInput
          key={label}
          id={`${id}_${inputId}`}
          label={label}
          type={type}
          value={values[inputId]}
          className="mt-20"
          rules={{
            required: required && requiredErrorMessage,
            pattern: {
              ...pattern,
            },
          }}
        />
      ),
    )}
  </>
);

AdditionalContacts.propTypes = {
  id: PropTypes.string.isRequired,
  inputs: PropTypes.array.isRequired,
};

export default AdditionalContacts;
